/* eslint-disable @typescript-eslint/default-param-last */
import { GET_RECRUITER } from '../constants/ActionTypes';
import initialState from '../store/initialState';
import { IRecruiterActionType } from '../types/recruiter.types';

const recruiterReducer = (
  state = initialState.recruiter,
  action: IRecruiterActionType
) => {
  switch (action.type) {
    case `${GET_RECRUITER}_SUCCESS`:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default recruiterReducer;
